<template>
  <div id="team" class="team desktop-team">
    <div class="horizontal"></div>
    <div class="team-wrapper">
      <div class="left">
        <img
          class="picture"
          src="@/assets/images/team/pic01.jpg"
          alt=""
          v-scroll-reveal.reset="{
            delay: 200,
            distance: '250px',
            origin: 'left',
          }"
        />
        <div
          class="picture-text"
          v-scroll-reveal.reset="{
            delay: 200,
            distance: '250px',
            origin: 'left',
          }"
        >
          Ehepaar Ulrike und Georg Rauch
        </div>
      </div>
      <div class="right">
        <div
          class="text"
          v-html="$texte.cast.protagonisten"
          v-scroll-reveal.reset="{ delay: 500 }"
        ></div>
        <div
          class="text"
          v-html="$texte.cast.crew"
          v-scroll-reveal.reset="{ delay: 600 }"
        ></div>
      </div>
      <div
        class="headline-box"
        v-scroll-reveal.reset="{
          delay: 200,
          distance: '250px',
          origin: 'right',
        }"
      >
        <div class="headline headline-redbox">Team</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.team {
  overflow-x: hidden;
  background-color: var(--clr-blau);
  color: white;
  .horizontal {
    margin-bottom: 20px;
  }
  .team-wrapper {
    position: relative;
    display: flex;
    max-width: 1024px;
    margin-inline: auto;
    padding-block: 2em;
    .headline-box {
      position: absolute;
      z-index: 1;
      top: 35px;
      left: 50%;
      // transform: translateX(-50%);
      margin-left: -20px;
      width: 1280px;
      border-bottom: 1px solid white;
      text-align: left;
      .headline-redbox {
        padding-left: 4rem;
      }
    }
    .right {
      position: relative;
      display: flex;
      width: 464px;
      flex-direction: column;
      align-items: flex-start;
      padding-top: 5em;
      .text:not(:first-child) {
        margin-top: 30px;
      }
    }
    .left {
      display: flex;
      justify-content: flex-end;
      width: 560px;
      padding-top: 445px;
      padding-right: 2em;
      .picture-text {
        padding-right: 10px;
      }
      .picture {
        position: absolute;
        z-index: 0;
        top: 50px;
        left: -180px;
        width: 702px;
        height: 421px;
      }
    }
  }
}
</style>
